import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import SkillsPreview from './components/SkillsPreview';
import ProjectShowcase from './components/ProjectShowcase';
import ProfessionalSummary from './components/ProfessionalSummary';
import CallToAction from './components/CallToAction';
import Icon from '../../components/AppIcon';


const HomeLanding = () => {
  useEffect(() => {
    // Smooth scroll behavior for anchor links
    const handleSmoothScroll = (e) => {
      const target = e?.target?.getAttribute('href');
      if (target && target?.startsWith('#')) {
        e?.preventDefault();
        const element = document.querySelector(target);
        if (element) {
          element?.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bello Fawas - Full-Stack Developer | Kiddy-DEV</title>
        <meta 
          name="description" 
          content="Experienced full-stack developer specializing in React, Node.js, and modern web technologies. 5+ years building scalable applications for startups and enterprises." 
        />
        <meta name="keywords" content="full-stack developer, React developer, Node.js, web development, portfolio, Bello Fawas" />
        <meta property="og:title" content="Bello Fawas - Full-Stack Developer" />
        <meta property="og:description" content="Passionate developer creating innovative digital solutions with 5+ years of experience" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://devportfoliopro.com/home-landing" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          {/* Hero Section */}
          <HeroSection />
          
          {/* Skills Preview */}
          <SkillsPreview />
          
          {/* Project Showcase */}
          <ProjectShowcase />
          
          {/* Professional Summary */}
          <ProfessionalSummary />
          
          {/* Call to Action */}
          <CallToAction />
        </main>

        {/* Footer */}
        <footer className="bg-card border-t border-border py-12">
          <div className="container mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Brand */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-sm">BF</span>
                  </div>
                  <span className="text-xl font-semibold text-foreground">Bello Fawas</span>
                </div>
                <p className="text-muted-foreground mb-4 max-w-md">
                  Full-stack developer passionate about creating exceptional digital experiences. 
                  Let's build something amazing together.
                </p>
                <div className="flex space-x-4">
                  <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <Icon name="Github" size={20} />
                  </a>
                  <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <Icon name="Linkedin" size={20} />
                  </a>
                  <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <Icon name="Twitter" size={20} />
                  </a>
                  <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <Icon name="Mail" size={20} />
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-semibold text-foreground mb-4">Quick Links</h4>
                <ul className="space-y-2">
                  <li><a href="/about-experience" className="text-muted-foreground hover:text-primary transition-colors">About</a></li>
                  <li><a href="/portfolio-projects" className="text-muted-foreground hover:text-primary transition-colors">Portfolio</a></li>
                  <li><a href="/contact-form" className="text-muted-foreground hover:text-primary transition-colors">Contact</a></li>
                  <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Resume</a></li>
                </ul>
              </div>

              {/* Services */}
              <div>
                <h4 className="font-semibold text-foreground mb-4">Services</h4>
                <ul className="space-y-2">
                  <li><span className="text-muted-foreground">Web Development</span></li>
                  <li><span className="text-muted-foreground">Mobile Apps</span></li>
                  <li><span className="text-muted-foreground">UI/UX Design</span></li>
                  <li><span className="text-muted-foreground">Consulting</span></li>
                </ul>
              </div>
            </div>

            <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-muted-foreground text-sm">
                © {new Date()?.getFullYear()} Bello Fawas. All rights reserved.
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="#" className="text-muted-foreground hover:text-primary text-sm transition-colors">Privacy Policy</a>
                <a href="#" className="text-muted-foreground hover:text-primary text-sm transition-colors">Terms of Service</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default HomeLanding;